'use es6';

import { fromJS } from 'immutable';
import * as colors from '../../../constants/colors';
export const defaultHiddenAxisOptions = fromJS({
  type: 'category',
  categories: [''],
  lineColor: 'transparent',
  lineWidth: 1,
  gridLineColor: colors.BATTLESHIP_TRANSPARENT,
  gridLineWidth: 0,
  tickColor: 'transparent',
  labels: {
    style: {
      color: 'inherit'
    }
  },
  stackLabels: {
    style: {
      color: 'inherit'
    }
  },
  title: {
    text: null,
    style: {
      color: 'inherit'
    }
  },
  reversedStacks: false
});